import React from 'react';
import {
    Grid,
    Card,
    CardContent,
    Typography,
    Box,
    Chip,
    alpha,
    useTheme,
} from '@mui/material';
import {
    Whatshot as FlareIcon,
    TrendingUp as TrendingIcon,
    ArrowForward as ArrowForwardIcon
} from '@mui/icons-material';

const TrendCard = ({ item, index }) => {
    const theme = useTheme();

    return (
        <Grid xs={12} sm={6} md={4} lg={3}>
            <Card
                component="a"
                href={`https://www.google.com/search?q=${encodeURIComponent(item.topic)}`}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                    display: 'block',
                    textDecoration: 'none',
                    height: '100%',
                    borderRadius: 4,
                    background: theme.palette.mode === 'dark'
                        ? `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.8)}, ${alpha(theme.palette.background.paper, 0.4)})`
                        : `linear-gradient(135deg, #ffffff, #f9fafb)`,
                    backdropFilter: 'blur(10px)',
                    border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: `0 12px 30px ${alpha(theme.palette.primary.main, 0.12)}`,
                        borderColor: alpha(theme.palette.primary.main, 0.3),
                        '& .rank-badge': {
                            transform: 'rotate(0deg) scale(1.1)',
                            bgcolor: theme.palette.primary.main,
                            color: '#fff'
                        },
                        '& .arrow-icon': {
                            transform: 'translateX(4px)',
                            opacity: 1
                        }
                    }
                }}
            >
                {/* Rank Badge */}
                <Box
                    className="rank-badge"
                    sx={{
                        position: 'absolute',
                        top: 20,
                        right: 20,
                        width: 32,
                        height: 32,
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '0.85rem',
                        fontWeight: 800,
                        bgcolor: alpha(theme.palette.text.primary, 0.05),
                        color: theme.palette.text.secondary,
                        transition: 'all 0.3s ease',
                        transform: 'rotate(-10deg)',
                        zIndex: 2
                    }}
                >
                    {index + 1}
                </Box>

                <CardContent sx={{ p: 3, pt: 4 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
                        <Box sx={{
                            p: 1,
                            borderRadius: '12px',
                            bgcolor: alpha(theme.palette.warning.main, 0.1),
                            color: theme.palette.warning.main,
                            display: 'flex'
                        }}>
                            <FlareIcon sx={{ fontSize: 20 }} />
                        </Box>
                        <Chip
                            label="Rising"
                            size="small"
                            sx={{
                                height: 20,
                                fontSize: '0.65rem',
                                fontWeight: 800,
                                bgcolor: alpha(theme.palette.success.main, 0.1),
                                color: theme.palette.success.main,
                                border: 'none'
                            }}
                        />
                    </Box>

                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 800,
                            lineHeight: 1.4,
                            mb: 2,
                            color: theme.palette.text.primary,
                            letterSpacing: '-0.01em',
                            minHeight: '2.8em',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden'
                        }}
                    >
                        {item.topic}
                    </Typography>

                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        pt: 2,
                        borderTop: `1px solid ${alpha(theme.palette.divider, 0.05)}`
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <TrendingIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                                Google Trends
                            </Typography>
                        </Box>

                        <ArrowForwardIcon
                            className="arrow-icon"
                            sx={{
                                fontSize: 18,
                                color: theme.palette.primary.main,
                                opacity: 0,
                                transition: 'all 0.3s ease'
                            }}
                        />
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    );
};

export default TrendCard;
